import AdvancedController from "./advanced-controller"
import gsap from 'gsap';
import { Breakpoints } from './breakpoints';

const HEADER_SCROLL_OFFSET = 151;

const SCROLL_DIR_NONE = 0;
const SCROLL_DIR_UP = -1;
const SCROLL_DIR_DOWN = 1;
const SCROLL_VELOCITY_THRESHOLD = 2;
export default class HeaderController extends AdvancedController {

    static values = {
        isNavToggled: Boolean,
        isSearchToggled: Boolean,
        isScrolled: Boolean,
    }

    static targets = [
        "navToggle",
        "searchForm",
        "searchField",
        "searchToggleButton"
    ]

    v = 0

    lastY = -1

    scrollDir = 0

    connect() {
        super.connect();
        this.navMainTarget = document.getElementById('nav-main')
        // outside click close
        window.addEventListener('click', (e) => {
            if (this.isSearchToggledValue && !this.searchFormTarget.contains(e.target) && !this.searchToggleButtonTarget.contains(e.target)) {
                this.isSearchToggledValue = false
                this._handleState();
            }
        })

        // force open when the mouse enters the header (green expander)
        this.element.addEventListener('mouseenter', () => {
            if (this.isScrolledValue) {
                this.isScrolledValue = false
                this.toggleIsScrolled();
                this.messageBlockNavHover();
            }
        })

        // force close when the mouse leaves the header
        this.element.addEventListener('mouseleave', () => {
            if (window.scrollY >= HEADER_SCROLL_OFFSET) {
                this.isScrolledValue = true
                this.messageCloseNav();
                this.toggleIsScrolled();
            }
        })

        // open/close logic during scroll
        this.lastY = window.scrollY
        requestAnimationFrame(this.updateIsScrolled.bind(this))

        // if the breakpoint changes the height of the navmain needs to adapt/reset
        this.breakpoints = new Breakpoints();
        this.breakpoints.on('changed', () => {
            if (this.breakpoints.breakpointUp('md')) {
                this.navMainTarget.style.height = 'auto'
            } else {
                this.navMainTarget.style.height = `${this._getNavMobileHeight()}px`
            }
        })
    }

    updateIsScrolled() {
        // calculate the delta in PX
        const delta = window.scrollY - this.lastY

        // either add a fraction of the delta to the v
        if (delta)
            this.v += delta / 10
        // or slowly dampen it
        else
            this.v /= 2

        // smaller values than 1px are set to 0 (in both directions)
        if (Math.abs(this.v) < 1) {
            this.v = 0
        }

        // check the velocity and map to the scroll direction
        if (this.v > SCROLL_VELOCITY_THRESHOLD) {
            this.scrollDir = SCROLL_DIR_DOWN;
        } else if (this.v < -1 * SCROLL_VELOCITY_THRESHOLD) {
            this.scrollDir = SCROLL_DIR_UP;
        } else {
            this.scrollDir = SCROLL_DIR_NONE;
        }

        const scrolledBeforeState = this.isScrolledValue ? true : false

        // depending on the direction decide about the scroll state
        if (window.scrollY < HEADER_SCROLL_OFFSET) {
            // force show the header when on top of the page
            this.isScrolledValue = false
        } else if (this.scrollDir === SCROLL_DIR_UP) {
            this.isScrolledValue = false
        } else if (this.scrollDir === SCROLL_DIR_DOWN) {
            this.isScrolledValue = true
        } else {
            this.isScrolledValue = scrolledBeforeState
        }

        // only if the state has changed toggle the class
        if (scrolledBeforeState !== this.isScrolledValue) {
            this.toggleIsScrolled();
            this.messageCloseNav();
            this._closeSearch();
        }

        this.lastY = window.scrollY

        requestAnimationFrame(this.updateIsScrolled.bind(this))
    }

    toggleIsScrolled() {
        this.element.classList.toggle('-is-scrolled', this.isScrolledValue)
    }

    onToggleClick(e) {
        e.preventDefault();
        this.isNavToggledValue = !this.isNavToggledValue;
        if (this.isNavToggledValue) this.isSearchToggledValue = false
        this._handleState();
    }

    onSearchToggle(e) {
        e.preventDefault();
        this.isSearchToggledValue = !this.isSearchToggledValue;
        if (this.isSearchToggledValue) this.isNavToggledValue = false
        this._handleState();
    }

    _closeSearch() {
        this.isSearchToggledValue = false;
        this._handleState();
    }

    _handleClasses() {
        this.element.classList.toggle('-nav-toggled', this.isNavToggledValue)
        this.element.classList.toggle('-search-toggled', this.isSearchToggledValue)
    }

    _handleState() {
        this._handleClasses();

        if (this.isNavToggledValue) {
            this.navMainTarget.style.display = "flex"
            if (this.breakpoints.breakpointDown('md')) {
                gsap.fromTo(this.navMainTarget, { height: '0px', transformOrigin: 'top' }, { height: `${this._getNavMobileHeight()}px` })
            }
        } else {
            if (this.breakpoints.breakpointDown('md')) {
                gsap.fromTo(this.navMainTarget, { height: `${this._getNavMobileHeight()}px` }, {
                    height: '0px',
                    onComplete: () => {
                        this.navMainTarget.style.display = "none"
                    }
                })
            } else {
                this.navMainTarget.style.display = "none"
            }
        }
        if (this.isSearchToggledValue) {
            this.searchFormTarget.style.display = "flex"
            gsap.fromTo(this.searchFormTarget, { scale: 0 }, { scale: 1 })
            this.searchFieldTarget.focus()
        } else {
            gsap.to(this.searchFormTarget, {
                scale: 0, onComplete: () => {
                    this.searchFormTarget.style.display = "none"
                }
            })
        }
    }

    _getNavMobileHeight() {
        return window.innerHeight - this.element.offsetHeight
    }

    messageCloseNav() {
        for (const controller of this.getAllControllers("nav-main-sub-menu")) {
            controller.messageClose();
        }
        this.isNavToggledValue = false
        this._handleState();
    }

    messageBlockNavHover() {
        for (const controller of this.getAllControllers("nav-main-sub-menu")) {
            controller.messageBlockHover();
        }
    }

}